const singleCircleSliderSections = document.querySelectorAll( ".single-circle-slider" );

singleCircleSliderSections.forEach( ( section ) => {
  // console.log(section);
  const sliderDiv = section.querySelector( ".slider" );
  const slides = section.querySelectorAll( " .slide" );
  const controlsContainer = section.querySelector( ".slider-controls" );
  // console.log(controlsContainer);
  const numSlidesLg = sliderDiv.dataset.cols || 3;

  if ( sliderDiv && slides.length > 0 ) {
    const overflowSlider = tns( {
      container: sliderDiv,
      autoplay: true,
      nav: false,
      loop: false,
      autoplayButtonOutput: false,
      controlsContainer: controlsContainer,
      speed: 500,
      gutter: 36,
      items: 1,
      responsive: {
        768: {
          gutter: 12,
          items: numSlidesLg,
        },
      },
    } );
  }
} );
